export default {
  resorder_details: "Order Details",
  resback: "Back",

  resorder_id: "Order ID",
  resorder_date: "Order Date",
  ressupplier: "Supplier",
  restotal_amount: "Total Amount",

  resrestaurant_details: "Restaurant Details",
  ressupplier_details: "Supplier Details",

  resname: "Name",
  rescontact: "Contact",
  resmobile: "Mobile",
  resemail: "Email",
  resaddress: "Address",

  resdelivery_details: "Delivery Details",
  resdelivery_completed: "Delivery Completed",

  resdelivery_type: "Delivery Type",
  resdriver: "Driver",
  resdriver_mobile: "Driver Mobile",
  resvehicle_type: "Vehicle Type",
  resvehicle_number: "Vehicle Number",
  resvehicle: "Vehicle",
  respartner: "Partner",
  resestimated_arrival: "Estimated Arrival",

  resrecurring_schedule: "Recurring Schedule",
  resfrequency: "Frequency",
  resdays: "Days",
  resstart_date: "Start Date",
  resend_date: "End Date",
  resnext_run: "Next Run",
  resstatus: "Status",

  resorder_items: "Order Items",
  resitem: "Item",
  resqty: "Qty",
  resprice: "Price",

  restrack_order: "Track Your Order",
  ressubmit_review: "Submit Review",
  resreport_issue: "Report Issue",
  resview_invoice: "View Invoice",
  rescreate_grn: "Create / View GRN",

  resplaced: "Placed",
  resconfirmed: "Confirmed",
  resdelivered: "Delivered",
  rescancelled: "Cancelled",
  resout_for_delivery: "Out For Delivery",
  resshop_no: "Shop No",
  reszone: "Zone",
};